import React from "react";
import { AuthServiceErrorCode } from "@sportal/api";

import { getSubscriberInfo } from "../../store/root.selectors";
import { LoginRouter } from "../LoginRouter";
import { useLoadableSlice } from "../../store/shared";
import { loadInfo } from "../../store/info/info.actions";
import ErrorPage, {
  shouldShowErrorPage,
} from "../../pages/errorPage/ErrorPage";

export const withAuthGuard = (Component) => () => {
  const subscriberInfo = useLoadableSlice(loadInfo(), getSubscriberInfo);

  if (subscriberInfo === null) {
    return null;
  }

  if (shouldShowErrorPage(subscriberInfo, AuthServiceErrorCode.GENERIC)) {
    return <ErrorPage />;
  }

  const isUserAuthenticated = !!subscriberInfo.id;

  return isUserAuthenticated ? <Component /> : <LoginRouter />;
};
